import { RootState } from '../../RootState';
import selectRequiredSettings from './selectRequiredSettings';

const selectLocale = (state: RootState): string => {
  const settings = selectRequiredSettings(state);
  return settings.locale;
};

export default selectLocale;
